import { IStockMovementState } from "./reducer";

const initialState: IStockMovementState = {
  stock_movements: [],
  loading: false,
};

export default initialState;
